import React, { useState } from 'react';
import { Accordion, Form } from 'react-bootstrap';
import { FaSearch, FaChevronDown, FaChevronUp } from '../../../icons';

interface FAQ {
  id: string;
  question: string;
  answer: string;
}

interface FAQSectionProps {
  faqs: FAQ[];
  searchTerm: string;
  onSearchChange: (term: string) => void;
}

const FAQSection: React.FC<FAQSectionProps> = ({
  faqs,
  searchTerm,
  onSearchChange
}) => {
  // Start with no active accordion item (all closed)
  const [activeKey, setActiveKey] = useState<string | null>(null);

  const handleSelect = (eventKey: string | null) => {
    // Toggle: if clicking the same item, close it; otherwise, open the clicked item
    setActiveKey(activeKey === eventKey ? null : eventKey);
  };

  const filteredFaqs = faqs.filter(
    (faq) =>
      faq.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
      faq.answer.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="faq-container">
      {/* Search Box - Only show if there are FAQs */}
      {faqs.length > 0 && (
        <div className="search-container mb-4">
          <div className="search-input-wrapper">
            <Form.Control
              type="text"
              placeholder="Search"
              value={searchTerm}
              onChange={(e) => onSearchChange(e.target.value)}
              className="search-input"
            />
            <FaSearch className="search-icon" />
          </div>
        </div>
      )}

      {/* FAQ Accordion */}
      <div className="faq-section">
        <Accordion activeKey={activeKey} onSelect={handleSelect}>
          {filteredFaqs.map((faq) => (
            <Accordion.Item key={faq.id} eventKey={faq.id} className="faq-item">
              <Accordion.Header>
                <span>{faq.question}</span>
                {activeKey === faq.id ? <FaChevronUp /> : <FaChevronDown />}
              </Accordion.Header>
              <Accordion.Body>
                {faq.answer}
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>

        {filteredFaqs.length === 0 && searchTerm && (
          <div className="text-center py-4">
            <p className="text-muted">No FAQs found matching your search.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default FAQSection;